import type { OutreachData } from './useOutreach';

interface PeopleSearchCellProps {
  recordId: string;
  data: OutreachData;
  /** Asks again for this object alone; disabled while another gesture runs. */
  onRetry: () => void;
  working: boolean;
}

const LABELS = { searching: 'Recherche…', none: 'Personne trouvée', failed: 'Échec de la recherche' } as const;

/**
 * The first cell of an object nobody was found for (04/11/2026): a search that
 * ends says how it ended, and can be asked again, instead of going blank.
 */
export const PeopleSearchCell = ({ recordId, data, onRetry, working }: PeopleSearchCellProps) => {
  const state = data.peopleSearch(recordId);
  if (!state) return null;
  return (
    <span className="whitespace-nowrap text-xs text-domino-inkSoft">
      {LABELS[state]}
      {state !== 'searching' && (
        <button type="button" disabled={working} onClick={onRetry} className="ml-2 text-domino-aubergine hover:underline disabled:opacity-50">
          Réessayer
        </button>
      )}
    </span>
  );
};
